import React from 'react'

const NotAuthorised = () => {
  return (
    <div>NotAuthorised</div>
  )
}

export default NotAuthorised